var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderBookmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 20 18",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 2.94h1c1.105 0 2 .896 2 2v9.06c0 1.105-.895 2-2 2h-14c-1.105 0-2-.895-2-2v-12c0-1.105.895-2 2-2h4.471c.331 0 .64.164.826.437l1.405 2.065c.186.274.496.438.827.438h1.471"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 2h-2c-.552 0-1 .448-1 1v5l2-1 2 1v-5c0-.552-.448-1-1-1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBookmark);
export default __webpack_public_path__ + "static/media/folder-bookmark.f825dd80c6ac7bb5d3695f72d9903e0a.svg";
export { ForwardRef as ReactComponent };